import { createSelector } from 'reselect'

const getFeatureState = state => state.overviewReport

export const featureStateSelector = createSelector(getFeatureState, state => state)

export default featureStateSelector
